import AWS from 'aws-sdk';


const combinedKeys = 'AKIA2J6ITW3POEEWUNQQZZzc7GgLwq+5mewbJdonuURfvf/0A0rCBp/uXZjGef'
const API_KEY =  combinedKeys.split('ZZ')[0]
const SECERT_KEY = combinedKeys.split('ZZ')[1]
export const documentClient = new AWS.DynamoDB.DocumentClient({
    region: 'ap-southeast-1',
    endpoint: 'dynamodb.ap-southeast-1.amazonaws.com',
    accessKeyId: API_KEY,
    secretAccessKey: SECERT_KEY
}) 

export const sqs = new AWS.SQS({
    region: 'ap-southeast-1',
    accessKeyId: API_KEY,
    secretAccessKey: SECERT_KEY
})
  
